import * as React from 'react';
import { Link } from 'react-router-dom';

export class Home extends React.Component {
    public render() {
        return (
            <div>
                <h2>Welcome to the Nova Force Data Network (NFDN)!</h2>
				<h3>Links:</h3>
				<Link to="/events">Events</Link>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Home.tsx